import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {Link} from 'gatsby';

const Considerapp = () => {
  return (
    <div className="consider_usa p-100">
        <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={12} lg={6} xl={5} xxl={5}>
                        <div className="consider_content">
                                <h2>When to Consider Our Mobile Application Maintenance Services</h2>
                               <p>Consider our maintenance services for app performance glitches, compatibility issues, and new feature inclusion. Our dedicated team ensures seamless updates, bug fixes, and optimizations, guaranteeing users a smooth experience with our mobile application maintenance services.</p> 
                               <Link to="/contact"
                                  className="border_btn dark_btn" aria-label="TekRevol Contact">Let's Build Your Get Support</Link>
                        </div>
                    </Col>
                    <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="offset-xl-1">
                    <div className="consider-box">
                        <h6>Outdated Functionality:</h6>
                        <p>When your app's functionality becomes outdated or lacks user engagement, our mobile app maintenance revives it with cutting-edge features.</p>
                    </div>
                    <div className="consider-box">
                        <h6> Security Concerns:</h6>
                        <p>Get our maintenance services to ensure your app's security. We conduct regular audits and updates, safeguarding user data to maintain trust in your app.</p>
                    </div>
                    <div className="consider-box">
                        <h6>Compatibility Challenges:</h6>
                        <p>Ensure your app’s compatibility with the latest devices. We guarantee seamless integration for a consistent experience across diverse platforms.</p>
                    </div>
                    </Col>
                </Row>
            </Container>
    </div>
  )
}

export default Considerapp